// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"17":"custom-form","58":"club-form","136":"vpn-form","325":"custom-form-rub","327":"course-form","410":"vpn-card-change-button","476":"tour-form","596":"subscription","683":"donation-form-eur","716":"donation-form-rub","914":"custom-form-eur"}[chunkId] + ".css";
};